import { gql, useQuery } from '@apollo/client';
import { attachPendo } from './utils/externalConfig';
import RuntimeEnvironment from '../../config/runtime';

export const PENDO_CONFIG_QUERY = gql`
  query PendoConfig {
    pendoConfig {
      apiKey
      parentAccount {
        id
        account_salesforce_id
        name
      }
      account {
        id
        account_manager
        account_name
        name
        parent_account_name
        product_package
        pub_active
        pub_features
        pub_internal
        pub_package
        pub_salesforce_id
        services_package
        top_pub
        pub_id
      }
      visitor {
        id
        visitorId
        email
        full_name
        name
        portfolio_url
        preferred_lang
        reporting_category
        talent_status
        trained_by_talent
      }
    }
  }
`;

export default function PendoConfig() {
  const { loading, error, data } = useQuery(PENDO_CONFIG_QUERY);

  if (error) {
    // MONAUTO-3509: Pendo is third-party telemetry; failing to fetch config is
    // a non-incidenting degradation (no analytics for this session). Use
    // console.warn instead of logError to keep DevTools visibility while NOT
    // alerting Honeybadger / MONAUTO. attachPendo / window.pendo.initialize
    // below are already gated by the success branch, so Pendo is correctly
    // skipped on error.
    console.warn('Failed to fetch Pendo config; skipping Pendo init', error);
  } else if (!loading && data?.pendoConfig) {
    // HB 129843224 fired when GraphQL returned `{ pendoConfig: null }` with no
    // `error` (e.g. user not yet provisioned in Pendo). Destructure only when
    // the config payload is present.
    const {
      apiKey,
      account,
      parentAccount,
      visitor,
    } = data.pendoConfig;

    const payload = {
      visitor, account, parentAccount
    };

    if (RuntimeEnvironment.env === 'production') {
      attachPendo(apiKey);
      window.pendo.initialize(payload);
    }
    else {
      console.warn(`"${RuntimeEnvironment.env}" environment detected, will send the following Pendo payload in production:`, payload);
    }
  }

  return null;
}
